/*
 * @Author       : didi
 * @Date         : 2022/2/24 8:26 PM
 * @Description  : 
 */
import mpx from '@mpxjs/core'
import fetch from '@didi/mpx-fetch'
mpx.use(fetch)